
import { I18N } from "../I18N.js"

export class Modal {
	static DECISION = 'DECISION'
	_target

	/**
	 * Displays a modal dialog
	 * 
	 * @param {*} type If type = Modal.DECISION no close button is displayed in the upper right area
	 */
	constructor(type) {
		this._target = document.createElement('DIV')
		this._target.classList.add('modalCanvas')
		this._target.innerHTML = `
			<div class="modalShader"></div>
			<div class="card modal">
				${type === Modal.DECISION ? '' : `<button class="closeBtn" i18n>Close </button>`}
				<div class="modalContent"></div>
				<div class="btnGroup"></div>
			</div>
		`
		document.querySelector('body').appendChild(this._target)
		if (type !== Modal.DECISION) {
			I18N.translateElement(this._target)
			this._target.querySelector('.closeBtn').addEventListener('click', () => this.dismiss())
		}
	}

	setContentInnerHTML = html => {
		let contentElem = this._target.querySelector('.modalContent')
		contentElem.innerHTML = html
		contentElem = this._target.querySelector('.modalContent')
		I18N.translateElement(contentElem)
	}

	setButtonGroupInnerHTML = html => {
		let btnGroupElem = this._target.querySelector('.btnGroup')
		btnGroupElem.innerHTML = html
		btnGroupElem = this._target.querySelector('.btnGroup')
		I18N.translateElement(btnGroupElem)
	}

	/**
	 * Add a click handler to a button.
	 * 
	 * @param {*} btnIndex Index of first button is 0
	 * @param {*} handler A function to execute on click.
	 * Can return a Promise that has to be fulfilled before the dialog will be closed.
	 * Otherwise the dialog closes immediatly after click.
	 */
	setBtnClickHandler = (btnIndex, handler) => {
		const buttons = this._target.querySelectorAll('.btnGroup button')
		buttons[btnIndex].addEventListener('click', async () => {
			await handler()
			this.dismiss()
		})
	}

	dismiss = () => this._target.remove()

}